import '../Maintenance/maintenance.scss';

import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';
import { withRouter } from 'react-router';
import { IHistory } from 'src/interfaces';

import { UserModel } from '../../model/UserModel';
import { getAllUsers } from '../../services/userService';
import { BasePage } from '../reusableComponents/BasePage';
import { ListPage } from '../reusableComponents/ListPage';
import { UserListItem } from './UserListItem';

export interface IUserListProps extends DispatchProp<any> {
    userInstances: UserModel[];
    history: IHistory;
}

export class UserListImpl extends React.PureComponent<IUserListProps, {}> {
    constructor(props: IUserListProps) {
        super(props);
    }

    static defaultProps: IUserListProps;

    promise = async () => {
        if (UserModel.list().length <= 1) {
            await getAllUsers();
        }
    }

    renderAddUserButton = () => {
        return <div className="add-button" onClick={() => this.props.history.push('/user/create')} >
            Add User <i className="fa fa-plus-square" aria-hidden="true"></i>
        </div>;
    }

    render() {
        return (<BasePage pageTitle="Users" className="list-page-base" sideButton={this.renderAddUserButton()}>
            <ListPage
                instances={this.props.userInstances}
                listItemComponent={UserListItem}
                searchBy={['Access_Level', 'First_Name', 'Last_Name']}
                instanceOf={'plantInfo'}
                pageHeadings={['User ID', 'First Name', 'Last Name', 'Access Level']}
                promise={this.promise}
                cols={[2, 4, 3, 3]}
                searchPlaceHolder="Enter first name, last name or access level to search..."
                emptyListMessage="No Users found"
            />
        </BasePage>
        );
    }

}

export function mapStateToProps(state) {
    const userInstances = UserModel.list();
    return {
        userInstances
    };
}

export const UserList = withRouter(connect<{}, {}, IUserListProps>(mapStateToProps)(UserListImpl));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/UserList.tsx